/*
 * Türchen-Konfigurator – nativer Shopify-Adapter.
 *
 * Modell, Türblattmaße und der preiswirksame Gefällezustand liegen als echte
 * Shopify-Produkte und -Varianten vor. Kleine Komponentenprodukte werden
 * direkt von der Konfigurator-Section eingebettet. Die großen Maßprodukte
 * werden über eine paginierte Section-Rendering-Anfrage geladen, weil normale
 * Liquid-for-Loops nach 50 Einträgen und unpaginierte Variantenlisten nach 250
 * Einträgen enden.
 */
(function () {
  'use strict';

  function cent(euro) {
    return Math.round(Number(euro) * 100);
  }

  function pad3(wert) {
    return String(Number(wert)).padStart(3, '0');
  }

  function erstelle(optionen) {
    optionen = optionen || {};
    var katalogSelector = optionen.katalogSelector || '#tuer-tarif-katalog';
    var katalogCache = null;
    var resolverCache = {};

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function katalogLaden() {
      if (katalogCache) return katalogCache;
      var element = document.querySelector(katalogSelector);
      if (!element) throw new Error('Die Shopify-Tarifdaten fehlen auf dieser Seite.');

      var roh;
      try {
        roh = JSON.parse(element.textContent || '{}');
      } catch (e) {
        throw new Error('Die Shopify-Tarifdaten konnten nicht gelesen werden.');
      }

      var varianten = {};
      (roh.variants || []).forEach(function (variante) {
        if (variante && variante.sku) varianten[variante.sku] = variante;
      });
      katalogCache = {
        currency: roh.currency,
        variants: varianten,
        basisProducts: roh.basisProducts || {},
        resolverSection: roh.resolverSection || 'tuerchen-variant-resolver'
      };
      return katalogCache;
    }

    function aktiveWaehrung(katalog) {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        katalog.currency || 'EUR';
    }

    function variantePruefen(variante, sku, zielCent, bindung) {
      if (!variante) throw new Error('Die Tarifvariante ' + sku + ' fehlt im Shop.');
      if (!variante.available) throw new Error('Die Tarifvariante ' + sku + ' ist derzeit nicht verfügbar.');
      if (Number(variante.price) !== Number(zielCent)) {
        throw new Error('Der Deutschland-Marktpreis für ' + sku + ' ist nicht centgenau eingerichtet.');
      }
      if (bindung && (
        String(variante.option1) !== String(bindung.breite) ||
        String(variante.option2) !== String(bindung.hoehe)
      )) {
        throw new Error('Die Shopify-Variantenoptionen für ' + sku + ' stimmen nicht mit dem Fertigungsmaß überein.');
      }
      return variante;
    }

    function varianteFuer(katalog, sku, zielCent) {
      return variantePruefen(katalog.variants[sku], sku, zielCent);
    }

    function resolverDatenLesen(html) {
      var element = null;
      if (typeof DOMParser !== 'undefined') {
        var dokument = new DOMParser().parseFromString(String(html || ''), 'text/html');
        element = dokument.querySelector('[data-tuer-variant-page]');
      }

      var jsonText = element && element.textContent;
      if (!jsonText) {
        var treffer = String(html || '').match(
          /<script[^>]*data-tuer-variant-page[^>]*>([\s\S]*?)<\/script>/i
        );
        jsonText = treffer && treffer[1];
      }
      if (!jsonText) throw new Error('Die Shopify-Tarifseite konnte nicht gelesen werden.');

      var daten;
      try {
        daten = JSON.parse(jsonText);
      } catch (e) {
        throw new Error('Die Shopify-Tarifseite enthält ungültige Variantendaten.');
      }
      if (!daten || !Array.isArray(daten.variants)) {
        throw new Error('Die Shopify-Tarifseite enthält keine Variantenliste.');
      }
      return daten;
    }

    function resolverSeiteLaden(katalog, handle, seite) {
      var url = root() + 'products/' + encodeURIComponent(handle) +
        '?section_id=' + encodeURIComponent(katalog.resolverSection) + '&page=' + Number(seite);
      return fetch(url, { headers: { 'Accept': 'text/html' } }).then(function (antwort) {
        if (!antwort.ok) {
          throw new Error('Das Shopify-Tarifprodukt ' + handle + ' ist nicht erreichbar (' + antwort.status + ').');
        }
        return antwort.text();
      }).then(resolverDatenLesen);
    }

    function basisVariantenLaden(katalog, handle) {
      if (!handle) throw new Error('Das Shopify-Maßprodukt ist nicht konfiguriert.');
      if (resolverCache[handle]) return resolverCache[handle];

      resolverCache[handle] = resolverSeiteLaden(katalog, handle, 1).then(function (ersteSeite) {
        var seiten = Math.max(1, Number(ersteSeite.pages) || 1);
        if (seiten > 20) {
          throw new Error('Das Shopify-Tarifprodukt hat unerwartet viele Variantenseiten.');
        }
        var weitere = [];
        for (var seite = 2; seite <= seiten; seite++) {
          weitere.push(resolverSeiteLaden(katalog, handle, seite));
        }
        return Promise.all([ersteSeite].concat(weitere));
      }).then(function (seitenDaten) {
        var varianten = {};
        seitenDaten.forEach(function (seite) {
          if (seite.handle && seite.handle !== handle) {
            throw new Error('Die Shopify-Tarifseite gehört nicht zum erwarteten Maßprodukt.');
          }
          (seite.variants || []).forEach(function (variante) {
            if (variante && variante.sku) varianten[variante.sku] = variante;
          });
        });
        return varianten;
      }).catch(function (fehler) {
        delete resolverCache[handle];
        throw fehler;
      });
      return resolverCache[handle];
    }

    function basisVarianteFuer(katalog, handle, sku, zielCent, bindung) {
      return basisVariantenLaden(katalog, handle).then(function (varianten) {
        return variantePruefen(varianten[sku], sku, zielCent, bindung);
      });
    }

    function basisBindung(katalog, ergebnis) {
      var modellId = ergebnis.modell && ergebnis.modell.id;
      var produkt = modellId && katalog.basisProducts[modellId];
      if (!produkt || !produkt.code) {
        throw new Error('Für das gewählte Zaunmodell ist kein Shopify-Maßprodukt konfiguriert.');
      }

      var breite = Number(ergebnis.breite_cm);
      var hoehe = Number(ergebnis.hoehe_cm);
      if (!Number.isInteger(breite) || !Number.isInteger(hoehe)) {
        throw new Error('Türblattbreite und Türblatthöhe müssen ganzzahlige Tarifmaße sein.');
      }
      var gefaelle = !!(ergebnis.gefaelle && ergebnis.gefaelle.gewaehlt);
      var zustand = gefaelle ? 'gefaelle' : 'eben';
      var handle = produkt[zustand];
      if (!handle) {
        throw new Error('Das Shopify-Maßprodukt für ' + produkt.code + ' (' + zustand + ') ist nicht konfiguriert.');
      }

      return {
        handle: handle,
        sku: 'ZT-KONF-MASS-' + String(produkt.code).toUpperCase() + '-' +
          (gefaelle ? 'G' : 'E') + '-B' + pad3(breite) + '-H' + pad3(hoehe),
        breite: breite,
        hoehe: hoehe,
        zustand: zustand
      };
    }

    function komponentenEigenschaften(meta, bezeichnung) {
      return {
        '_Konfiguration': meta.konfigId,
        '_Komponente': bezeichnung
      };
    }

    function position(variante, eigenschaften) {
      return {
        id: variante.id,
        quantity: 1,
        properties: eigenschaften
      };
    }

    function inDenWarenkorb(positionen) {
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: positionen })
      }).then(function (antwort) {
        return antwort.json().catch(function () { return {}; }).then(function (daten) {
          if (!antwort.ok) {
            throw new Error(daten.description || daten.message ||
              'Der Warenkorb hat nicht geantwortet (' + antwort.status + ').');
          }
          window.location.href = root() + 'cart';
          return daten;
        });
      });
    }

    return {
      addToCart: function (ergebnis, meta) {
        return Promise.resolve().then(function () {
          var katalog = katalogLaden();
          if (aktiveWaehrung(katalog) !== 'EUR') {
            throw new Error('Der Zauntürchen-Konfigurator ist derzeit nur für Bestellungen in EUR freigeschaltet.');
          }

          var aufschluesselung = ergebnis.preisaufschluesselung || {};
          var basisCent = cent(Number(aufschluesselung.tuer_grundpreis_brutto || 0) +
            Number(aufschluesselung.gefaelle_brutto || 0));
          var bindung = basisBindung(katalog, ergebnis);
          return basisVarianteFuer(katalog, bindung.handle, bindung.sku, basisCent, bindung).then(function (basis) {
            var positionen = [position(basis, meta.eigenschaften)];
            var summeCent = basisCent;

            if (ergebnis.beschlag && ergebnis.beschlag.enthalten) {
              var beschlagCent = cent(aufschluesselung.beschlag_brutto);
              var beschlag = varianteFuer(katalog, 'ZT-KONF-BESCHLAG', beschlagCent);
              positionen.push(position(beschlag,
                komponentenEigenschaften(meta, 'Türbeschlag-Sortiment')));
              summeCent += beschlagCent;
            }

            if (ergebnis.verstellbareBaender && ergebnis.verstellbareBaender.enthalten) {
              var baenderCent = cent(aufschluesselung.verstellbare_baender_brutto);
              var baender = varianteFuer(katalog, 'ZT-KONF-BAENDER', baenderCent);
              positionen.push(position(baender,
                komponentenEigenschaften(meta, 'Verstellbare Bänder')));
              summeCent += baenderCent;
            }

            var torpfosten = ergebnis.torpfosten || {};
            if (torpfosten.id === 'stahl') {
              throw new Error('Stahlpfosten sind wegen des noch offenen Eckkegelpreises derzeit nur auf Anfrage erhältlich. Bitte wähle vorhandene Pfosten.');
            }
            if (torpfosten.id && torpfosten.id !== 'vorhanden') {
              var pfostenCent = cent(aufschluesselung.torpfosten_brutto);
              var artikelcode = String(torpfosten.artikelcode || '').toUpperCase();
              var pfostenSku = 'ZT-KONF-PF-' + artikelcode + '-H' + pad3(torpfosten.preisstaffel_tuerhoehe_cm);
              var pfosten = varianteFuer(katalog, pfostenSku, pfostenCent);
              positionen.push(position(pfosten,
                komponentenEigenschaften(meta, 'Torpfosten ' + artikelcode + ' (Paar)')));
              summeCent += pfostenCent;
            }

            if (summeCent !== cent(ergebnis.shopPreis)) {
              throw new Error('Die Warenkorb-Komponenten stimmen nicht mit dem berechneten Gesamtpreis überein.');
            }
            return inDenWarenkorb(positionen);
          });
        });
      }
    };
  }

  window.TuerShopifyAdapter = { erstelle: erstelle };
}());
